import React from "react";
import { Redirect, Route } from "react-router-dom";
import { IonApp, IonRouterOutlet, setupConfig } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import QuestionnairePage from "./pages/QuestionnairePage";
/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

/* Bootstrap css */
import 'bootstrap/dist/css/bootstrap.min.css';

/* Theme variables */
import "theme/custom.scss";
import "theme/variables.css";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import PHQForm from "components/questionnaire/PHQForm";
import Login from "pages/login/login";
import PrivateRoute from "components/PrivateRoute";
import PHQList from "components/questionnaire/PHQList";
import Domain from "pages/domain-management"
import Menu from "layout/menus/Menu";
import Templates from "pages/templates";
import AddEditTemplate from "pages/templates/AddEditTemplate";
import Loading from "components/UI/Loading";
import PatientForms from "pages/patient-forms";
setupConfig({ mode: "ios" });

const App: React.FC = () => {

  return (
    <IonApp>
        <IonReactRouter>
          <Menu />
          <IonRouterOutlet id="maincontent">
                <PrivateRoute
                  exact
                  redirectPath="/login"
                  component={PatientForms}
                  path="/home"
                />
                <PrivateRoute
                  exact
                  redirectPath="/login"
                  component={PHQList}
                  path="/phqs"
                />
                <PrivateRoute
                  exact
                  redirectPath="/login"
                  component={PHQForm}
                  path="/phq/:phqId"
                />
                <PrivateRoute
                  exact
                  redirectPath="/login"
                  component={QuestionnairePage}
                  path="/phq/pages/:pageId"
                />
                <PrivateRoute
                  exact
                  redirectPath="/login"
                  component={Domain}
                  path="/domains"
                />
                <PrivateRoute
                  exact
                  redirectPath="/login"
                  component={Templates}
                  path="/templates"
                />
                <PrivateRoute
                  exact
                  redirectPath="/login"
                  component={AddEditTemplate}
                  path="/templates/:id"
                />
                <Route exact path="/login" component={Login} />
                <Route exact path="/" render={() => <Redirect to="/home" />} />
          </IonRouterOutlet>
        </IonReactRouter>
      <ToastContainer />
      <Loading />
    </IonApp>
  );
};

export default App;
